import { Icon, Text } from '@shared/widgets';
import EyeIcon from '@assets/icons/eye.svg';

interface ShowInReportsProps {
  icon?: React.ReactNode;
  showModal: () => void;
}

export const ShowInReports = (props: ShowInReportsProps) => {
  return (
    <div className='flex items-center cursor-pointer' onClick={props.showModal}>
      {props.icon ? (
        <div className='mr-1 '>{props.icon}</div>
      ) : (
        <div className='mr-1 opacity-60'>
          <Icon icon={<EyeIcon width='18' height='18' />} />
        </div>
      )}
      <Text className='underline'>Show</Text>
    </div>
  );
};
